import Highlight from '@tiptap/extension-highlight';
import { menuControlFor, activeMenuControlFor, toolbarFor } from './_get_menu_control';
import { colorHex } from './_color_hex';

const syncMenu = ({ editor }) => {
  const color = editor.getAttributes('highlight').color;
  const toolbar = toolbarFor(editor);

  const currentSwatch = toolbar?.querySelector('.highlight-control__current');
  if (currentSwatch) {
    currentSwatch.classList.toggle('highlight-control__current--none', !color);
    currentSwatch.style.backgroundColor = color || '';
  }

  const customInput = toolbar?.querySelector('input[data-command="highlight:set"]');
  if (customInput) {
    customInput.value = colorHex(color || '#000000').toLowerCase();
  }

  const previousControl = activeMenuControlFor(editor, 'highlight:set');
  const currentControl = color
    ? menuControlFor(editor, 'highlight:set', colorHex(color).toLowerCase())
    : null;

  if (previousControl !== currentControl) {
    previousControl?.classList?.toggle('active', false);
    currentControl?.classList?.toggle('active', true);
  }
};

export default [
  Highlight.extend({
    onCreate: syncMenu,
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }).configure({ multicolor: true }),
];
